import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const TopNavItemsContainer = forwardRef((props, ref) => {
  const { children, className, ...rest } = props

  const classes = ['dev_dash__top-nav-items--container', className]
    .join(' ')
    .trim()

  return (
    <ul className={classes} ref={ref} {...rest}>
      {children}
    </ul>
  )
})

TopNavItemsContainer.displayName = 'TopNavItemsContainer'
TopNavItemsContainer.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
}
